import { render, staticRenderFns } from "./DrivingSchoolBody.vue?vue&type=template&id=9a12a0d4&lang=pug"
import script from "./DrivingSchoolBody.vue?vue&type=script&lang=js"
export * from "./DrivingSchoolBody.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports